import { render, staticRenderFns } from "./EventWizard.vue?vue&type=template&id=0b474c42&"
import script from "./EventWizard.vue?vue&type=script&lang=js&"
export * from "./EventWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports